import React from 'react'

/**
 */
export const Context = React.createContext({ roomPlan: null })

/**
 */
export const Consumer = Context.Consumer
